import React, { useEffect, useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { usePrescriptionSave } from "../context/PrescriptionSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";

const VenyesTartozek = () => {
	const { order, updateOrder} = useOrder();
	const navigate = useStepNavigate();
	const { savePrescription, loading: prescriptionSaveLoading } = usePrescriptionSave();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
			navigate("/VenyekLista");
		}
	}, [order.hmeliorder?.hmeliorder_depot_prefix, navigate]);

	const handleNoClick = async () => {
		try {
			setLoading(true);

			const updatedOrder = {
				...order,
				venyek: order.venyek.map((veny, index) => (index === order.aktivVenyIndex ? { ...veny, components: [] } : veny)),
			};

			updateOrder(updatedOrder);

			const aktVeny = updatedOrder.venyek[order.aktivVenyIndex];
			const data = {
				hmeliorder_szam: order.hmeliorder?.hmeliorder_szam,
				veny: aktVeny,
			};

			const result = await savePrescription(data);
			if (result?.success) {
				navigate("/VenyekLista");
			}
			setLoading(false);
		} catch (error) {
			console.error("Hiba a vény mentésekor:", error);
			setLoading(false);
		}
	};

	return (
		<TablerLayout title="Van a vényen tartozék?">
			<div className="row justify-content-center">
				<div className="col-md-10 mb-4">
					<div className="container-xl">
						<div style={{ textAlign: "right", fontWeight: 500, fontSize: "1.1rem", marginBottom: 8 }}>
							{order.aktivVenyIndex + 1} / {order.venyek.length}. vény
						</div>
					</div>
					<div className="card-body text-center">
						<div className="d-flex flex-column flex-md-row justify-content-center gap-4 mb-3">
							<button type="button" className="btn btn-outline-primary w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold" style={{ minWidth: 180, fontSize: 22 }} onClick={handleNoClick} disabled={prescriptionSaveLoading}>
								Nincs
							</button>
							<button type="button" className="btn btn-primary w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold" style={{ minWidth: 180, fontSize: 22 }} onClick={() => navigate("/TartozekValaszto")} disabled={prescriptionSaveLoading}>
								Igen
							</button>
						</div>
					</div>
				</div>
				<div className="d-flex justify-content-between mt-4">
					
					<StepperNavButton
						side="left"
						label="Vissza"
						onClick={() => navigate('/CipoTipus')}
					/> 
					
				</div>
			</div>
		</TablerLayout>
	);
};

export default VenyesTartozek;
